import {
  getData, ifOkToJson, isDataFine, post
} from './index'
import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
let baseUrl3 = `${httpUrl.host}/gy-apartment`
let baseUrl4 = `${httpUrl.host}/gy-apartment`
// const baseUrl = '/api/gy-apartment'

class TreeApi {
  getYqInfo () {
    return post(`${baseUrl2}/yqInfo/getYqInfo`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getBuildingList () {
    return post(`${baseUrl2}/building/getBuildingList`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getVacancyRoomInfo (id) {
    if (id) {
      return post(`${baseUrl2}/roomInfo/getRoomInfoList/${id}`, {})
        .then(ifOkToJson)
        .then(getData)
    } else {
      return post(`${baseUrl2}/roomInfo/getRoomInfoList`, {})
        .then(ifOkToJson)
        .then(getData)
    }
  }
  getVacancyRoomInfoForPlatform (enterpriseCode) {
    return post(`${baseUrl2}/roomInfo/getVacancyRoomInfoForPlatform`, {
      enterpriseCode: enterpriseCode
    })
      .then(ifOkToJson)
      .then(getData)
  }
  getPageForParkManager () {
    return post(`${baseUrl4}/platform/agentRoom/getPageForParkManager`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getAllRoomInfoList () {
    return post(`${baseUrl2}/roomInfo/getRoomInfoList`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getRoomTree () {
    return post(`${baseUrl2}/roomInfo/getRoomTree`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  addPatchFloors (data) {
    return post(`${baseUrl2}/yqTree/addPatchFloors`, data)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getYqInfoList () {
    return post(`${baseUrl2}/yqTree/getYqInfoList`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getYqInfoChildrenById (code) {
    return post(`${baseUrl2}/yqTree/getYqInfoChildrenByCode/${code}`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  addyqInfo (department) {
    return post(`${baseUrl2}/yqTree/addyqInfo`, department)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  updateyqInfo (department) {
    return post(`${baseUrl2}/yqTree/updateyqInfo`, department)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  deleteyqInfoByCodes (code) {
    return post(`${baseUrl2}/yqTree/deleteyqInfoByCodes`, {'codes': code})
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getChildrenByCode (code, searchKey) {
    let searchKeyInfo = searchKey || ''
    if (code === 0) {
      searchKeyInfo = ''
    }
    return post(`${baseUrl2}/enterpriseInfo/getChildrenByCode/${code}`, {searchKey: searchKeyInfo})
      .then(ifOkToJson)
      .then(getData)
  }

  getDeviceTreeList () {
    return post(`${baseUrl3}/accessDevice/getDeviceTree`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getDeviceTreeForVenue () {
    return post(`${baseUrl3}/accessDevice/getDeviceListForVenue`, {})
      .then(ifOkToJson)
      .then(getData)
  }
}

const treeApi = new TreeApi()
export default treeApi
export {treeApi}



// WEBPACK FOOTER //
// ./src/view/api/TreeApi.js